import { AgeType, modifyAgeType } from 'lib/apis/utils';

export { AgeType, modifyAgeType };
